var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconXCircleFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.772C17.5227 21.772 22 17.2947 22 11.772C22 6.24925 17.5227 1.77197 12 1.77197C6.47727 1.77197 2 6.24925 2 11.772C2 17.2947 6.47727 21.772 12 21.772ZM7.29289 16.4793C6.90237 16.0888 6.90237 15.4556 7.29289 15.0651L10.586 11.772L7.29289 8.47883C6.90237 8.08831 6.90237 7.45514 7.29289 7.06462C7.68342 6.6741 8.31658 6.6741 8.70711 7.06462L12.0002 10.3578L15.2929 7.06511C15.6834 6.67459 16.3166 6.67459 16.7071 7.06511C17.0976 7.45564 17.0976 8.0888 16.7071 8.47932L13.4145 11.772L16.7071 15.0646C17.0976 15.4551 17.0976 16.0883 16.7071 16.4788C16.3166 16.8694 15.6834 16.8694 15.2929 16.4788L12.0002 13.1862L8.70711 16.4793C8.31658 16.8698 7.68342 16.8698 7.29289 16.4793Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconXCircleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconXCircleFilled.915bed857409dc4021920e318eb8471b.svg";